import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OpenTileLayoutService {
  breakpoints: any = {
    large: 1024,
    medium: 640,
    small: 480
  };

  constructor() { }

  public getColumns(container: any, tile: any, settings: any) {
    let columns;
    
    if (container) {
      const tileWidth = tile.offsetWidth;
      const style = getComputedStyle(tile, null);
      const length = settings.choices.length;
      let containerWidth = container.nativeElement.offsetWidth;
      let tileSize = tileWidth + parseInt(style.marginRight);
      let sizeCoefficient = tileSize / containerWidth;

      if (settings.size === 'large') {
        if (sizeCoefficient <= 0.25) {
          columns = 4;
        } else if (sizeCoefficient <= 0.33) {
          columns = 3;
        } else if (sizeCoefficient <= 0.5) {
          columns = 2;
        } else {
          columns = 1;
        }
      } else {
        if (
          sizeCoefficient <= 0.25 &&
          !(length === 9 || length === 6 || length === 5)
        ) {
          columns = 4;
        } else if (sizeCoefficient <= 0.33 && length !== 4) {
          columns = 3;
        } else if (sizeCoefficient <= 0.5) {
          columns = 2;
        } else {
          columns = 1;
        }
      }
    }
    return columns;
  }

}
